module.exports = __webpack_public_path__ + "img/cloudy.2d0410c5.svg";